import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { getProjects } from '../services/api';
import '../styles/Projects.css';

const Projects = () => {
  const { t } = useTranslation();
  const [projects, setProjects] = useState([]);
  const [filteredProjects, setFilteredProjects] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [selectedProject, setSelectedProject] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchProjects();
  }, []);

  const fetchProjects = async () => {
  try {
    const response = await getProjects();
    // التعامل مع الـ response الصحيح
    const projectsData = response.data || response;
    const activeProjects = projectsData.filter(p => p.status === 'active');
    setProjects(activeProjects);
    setFilteredProjects(activeProjects);
  } catch (error) {
    console.error('Error fetching projects:', error);
  } finally {
    setLoading(false);
  }
};
  // استخراج الفئات الفريدة
  const categories = ['all', ...new Set(projects.map(p => p.category).filter(Boolean))];

  const filterProjects = (category) => {
    setSelectedCategory(category);
    if (category === 'all') {
      setFilteredProjects(projects);
    } else {
      setFilteredProjects(projects.filter(p => p.category === category));
    }
  };

  const openProjectModal = (project) => {
    setSelectedProject(project);
    document.body.style.overflow = 'hidden';
  };

  const closeProjectModal = () => {
    setSelectedProject(null);
    document.body.style.overflow = 'auto';
  };

  if (loading) {
    return (
      <section id="projects" className="projects">
        <div className="projects-loading">{t('projects.loading')}</div>
      </section>
    );
  }

  return (
    <section id="projects" className="projects">
      <div className="projects-container">
        <div className="section-header">
          <h2 className="section-title" data-aos="fade-up">
            {t('projects.title')}
          </h2>
          <div className="section-divider"></div>
          <p className="section-subtitle" data-aos="fade-up" data-aos-delay="100">
            {t('projects.subtitle')}
          </p>
        </div>

        {/* Filter Buttons */}
        {categories.length > 1 && (
          <div className="projects-filter" data-aos="fade-up" data-aos-delay="200">
            {categories.map((category) => (
              <button
                key={category}
                className={`filter-btn ${selectedCategory === category ? 'active' : ''}`}
                onClick={() => filterProjects(category)}
              >
                {category.charAt(0).toUpperCase() + category.slice(1)}
              </button>
            ))}
          </div>
        )}

        {/* Projects Grid */}
        {filteredProjects.length === 0 ? (
          <div className="no-projects">
            <p>{t('projects.noProjects')}</p>
          </div>
        ) : (
          <div className="projects-grid">
            {filteredProjects.map((project, index) => (
              <div 
                key={project.id} 
                className="project-card"
                data-aos="fade-up"
                data-aos-delay={index * 100}
                onClick={() => openProjectModal(project)}
              >
                <div className="project-image-wrapper">
                  {project.main_image ? (
                    <img
                      src={`${process.env.REACT_APP_API_URL}${project.main_image}`}
                      alt={project.title}
                      className="project-image"
                    />
                  ) : (
                    <div className="project-image-placeholder">
                      <span>🏗️</span>
                    </div>
                  )}
                  <div className="project-overlay">
                    <span className="project-view-btn">{t('projects.viewDetails')}</span>
                  </div>
                </div>
                <div className="project-info">
                  <h3 className="project-title">{project.title}</h3>
                  {project.category && (
                    <span className="project-category">{project.category}</span>
                  )}
                  {project.location && (
                    <p className="project-location">📍 {project.location}</p>
                  )}
                  {project.year && (
                    <p className="project-year">📅 {project.year}</p>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Project Modal */}
      {selectedProject && (
        <div className="project-modal" onClick={closeProjectModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={closeProjectModal}>
              ✕
            </button>
            
            <div className="modal-header">
              <h2>{selectedProject.title}</h2>
              <div className="modal-meta">
                {selectedProject.category && (
                  <span className="modal-category">{selectedProject.category}</span>
                )}
                {selectedProject.location && (
                  <span className="modal-location">📍 {selectedProject.location}</span>
                )}
                {selectedProject.year && (
                  <span className="modal-year">📅 {selectedProject.year}</span>
                )}
              </div>
            </div>

            <div className="modal-body">
              {selectedProject.main_image && (
                <div className="modal-image">
                  <img
                    src={`${process.env.REACT_APP_API_URL}${selectedProject.main_image}`}
                    alt={selectedProject.title}
                  />
                </div>
              )}

              {selectedProject.description && (
                <div className="modal-description">
                  <h3>{t('projects.description')}</h3>
                  <p>{selectedProject.description}</p>
                </div>
              )}

              {selectedProject.images && selectedProject.images.length > 0 && (
                <div className="modal-gallery">
                  <h3>{t('projects.gallery')}</h3>
                  <div className="gallery-grid">
                    {selectedProject.images.map((image) => (
                      <div key={image.id} className="gallery-item">
                        <img
                          src={`${process.env.REACT_APP_API_URL}${image.image_url}`}
                          alt={image.caption || selectedProject.title}
                        />
                        {image.caption && (
                          <p className="gallery-caption">{image.caption}</p>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default Projects;